// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1n1OS","disabled":"FileBtn_disabled__1tXEb","warn":"FileBtn_warn__3shD4","fade":"FileBtn_fade__1X7kG"};